// src/components/ui/ServiceCard.jsx

import React, { useState } from "react";
import Skeleton from "./Skeleton";

function ServiceCard({ title, img }) {
  const [loaded, setLoaded] = useState(false);

  return (
   <div className="service-card">
  <div className="image-box">
    {!loaded && <div className="skeleton"></div>}

    <img
      src={img}
      alt={title}
      style={{ display: loaded ? "block" : "none" }}
      onLoad={() => setLoaded(true)}
    />
  </div>

  <h3>{title}</h3>
</div>

  );
}

export default ServiceCard;
